import React from 'react';
import Helmet from 'react-helmet';
import { PageContainer } from '../../components/Page';
import DangerousHTML from '../../components/DangerousHTML';
import { withRouteData } from 'react-static';
import {Link} from "@reach/router";

export default withRouteData(({ lawyer, slug, lawyers }) => (<React.Fragment>
  <Helmet title={lawyer ? lawyer.name : ''} />
  <PageContainer className='with-a-bit-of-spacing'>
    <div className="row">
      <div className='lawyerContent col-sm-offset-1 col-sm-10 col-md-offset-1 col-md-10 col-lg-offset-1 col-lg-7 page-content'>
        <h1>{lawyer ? lawyer.name : ''}</h1>
        <DangerousHTML html={lawyer ? lawyer.biography : ''} />
      </div>
      <div className="col-xs-12 col-sm-12 col-sm-offset-1 col-md-offset-0 col-md-12 col-lg-3 first-md first-lg lawyer-sidebar">
        {/*<LawyerGroup lawyers={lawyers} active={slug} />*/}
        <div className="lawyerGroup isEmbedded">
          <div className="lawyer active">
            <img src={lawyer ? lawyer.image : ''} alt={lawyer ? lawyer.name : ''} style={slug === 'harrison' ? {marginTop: '0px', transform: 'scaleX(-1)'} : { marginTop: '0px'}} />
          </div>
        </div>
        { lawyer && lawyer.practiceAreas && lawyer.practiceAreas.length > 0 &&  <hr/> }
        { lawyer && lawyer.practiceAreas && lawyer.practiceAreas.length > 0 && <h3>Practice Areas</h3> }
        { lawyer && lawyer.practiceAreas && lawyer.practiceAreas.length > 0 && <ul className="list-unstyled lawyer-picker-links">
          { Object.values(lawyer && lawyer.practiceAreas || {}).map(p => <li key={p.to}><Link to={p.to}>{p.text}</Link></li>)}
        </ul> }
        <hr/>
        <h3>Other Attorneys</h3>
        <ul className="list-unstyled lawyer-picker-links">
          { Object.values(lawyers || {}).filter(l => l.slug !== slug).map(l => <li key={l.slug}><Link to={`/lawyers/${l.slug}`}>{l.name}</Link></li>)}
        </ul>
      </div>
    </div>
  </PageContainer>
</React.Fragment>));
